// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warpContent[data-v-c7a32b6c] {\n  height: calc(100vh - 100px);\n  overflow: auto;\n  padding: 0 20px;\n}\n.el-descriptions-item__cell div[data-v-c7a32b6c] {\n  font-weight: bold;\n  font-size: 18px;\n}\n[data-v-c7a32b6c] .el-descriptions-item__label {\n  font-size: 16px;\n  color: #909399;\n}\n[data-v-c7a32b6c] .el-descriptions-item__cell {\n  /*height: 35px !important;*/\n  padding-bottom: 5px !important;\n}\n", ""]);
// Exports
module.exports = exports;
